import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { createApolloClient, createApolloCache } from 'providers/ApolloProvider';
import { QUERY_settingsPageFetchPositionById } from 'queries';
import { PositionTypeEnum, OrderStatusEnum } from 'types/graphql';

interface IRequestRemovePositionConfig {
  positionId: number;
  facilityId: number;
  positionType: PositionTypeEnum;
  teamMemberFilter: {
    byPrimaryCommunity: number[];
  };
  orderFilter: {
    forOrders: {
      withStatus: OrderStatusEnum[];
      withCommunity: number[];
    };
  };
}

interface IRequestRemovePositionSchema {
  positionId: string;
  facilityId: number;
  filter?: {
    byPositionId: string;
    byFacilityId: number;
  };
  positionType: PositionTypeEnum;
  teamMemberFilter: {
    byPrimaryCommunity: number[];
  };
  orderFilter: {
    forOrders: {
      withStatus: OrderStatusEnum[];
      withCommunity: number[];
    };
  };
}

const requestRemovePositionApolloClient = createApolloClient({ cache: createApolloCache() });

export const requestPositionJanesConfig = ({
  positionId,
  facilityId,
  positionType,
  teamMemberFilter,
  orderFilter,
}: IRequestRemovePositionConfig): ISSFBehaviorsOptions => ({
  client: requestRemovePositionApolloClient,
  key: 'SEND_TO_AGENCIES_REMOVE_POSITION_VIEW_QUERY',
  query: QUERY_settingsPageFetchPositionById,
  paginationType: 'InfiniteScroll',
  debounceTimeout: 500,
  payloadTransformer: (variables: IRequestRemovePositionSchema) => {
    return {
      ...variables,
      positionId: variables.positionId,
      type: variables.positionType,
      filter: {
        byPositionId: variables.positionId,
        byFacilityId: variables.facilityId,
      },
      teamMemberFilter: {
        byPrimaryCommunity: variables.teamMemberFilter.byPrimaryCommunity,
      },
      orderFilter: {
        forOrders: {
          withStatus: variables.orderFilter.forOrders.withStatus,
          withCommunity: variables.orderFilter.forOrders.withCommunity,
        },
      },
    };
  },
  pageSize: 20,
  variables: {},
  schema: {
    positionId: {
      initialValue: positionId,
    },
    facilityId: {
      initialValue: facilityId,
    },
    positionType: {
      initialValue: positionType,
    },
    teamMemberFilter: {
      initialValue: teamMemberFilter,
    },
    orderFilter: {
      initialValue: orderFilter,
    },
  },
});
